export enum GameStates {
  setPlayers = 'setPlayers',
  setScoreTarget = 'setScoreTarget',
  waitForRoundStart = 'waitForRoundStart',
  roundInProgress = 'roundInProgress',
  roundEnded = 'roundEnded',
  gameEnded = 'gameEnded'
}

// export type GameStates =
//   | "setPlayers"
//   | "setScoreTarget"
//   | "waitForRoundStart"
//   | "roundInProgress"
//   | "roundEnded"
//   | "gameEnded";
